import * as common from './common'
import * as product from './product'

export const validationHelper = {
  common,
  product,
}
